import SelectField from 'components/Inputs/SelectField/SelectField';
import { useMemo } from 'react';
import { useProvinceQuery } from 'utils/queries/location';
import { LocationSelectProps } from '.';

const ProvinceSelect: React.FC<LocationSelectProps> = ({
	control,
	name,
	label = 'State/Province',
	disabled,
	defaultValue,
	...rest
}) => {
	const { data, isLoading } = useProvinceQuery();
	const options = useMemo(
		() =>
			data?.map(({ id: value, name: label }) => ({
				label,
				value,
			})) || [],

		[data]
	);

	return (
		<SelectField
			label={label}
			control={control}
			name={`${name}.province_id`}
			required
			isLoading={isLoading}
			defaultValue={defaultValue}
			options={options}
			{...rest}
			disabled={disabled}
		/>
	);
};

export default ProvinceSelect;
